import { useEffect, useRef, useState } from 'react'
import { Ionicons } from '@expo/vector-icons'
import { Alert, Pressable } from 'react-native'
import theme from '../../../theme'
import { useFooterApp } from '../../redux/zustand/footerAppStore'
import { GpsFixIcon } from 'phosphor-react-native'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { getConection } from '../appBar/context/HeaderContext'
import { getAuthToken } from '../../utils/functions.utils'
import { apiUrl } from '../../config/config'
import { sendRequest } from '../../utils/FetchServices'
import { useToast } from '../../redux/zustand/useToast'
import { schedulesServices } from '../../../database/schedules.database'

export const UpdateLocationIcon = ({
    iconColor = undefined,
    iconSize = 24,
    style = null,
    userInfo = null,
    onUpdate = () => {},
}) => {
    const footer_app = useFooterApp((state) => state.footer_app)
    const [render, setRender] = useState(false)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const isSending = useRef(false)
    const { isConnected, hasInternet } = getConection()
    const setToast = useToast((toast) => toast.setToast)
    useEffect(() => {
        if (!footer_app || footer_app.length === 0) return
        const item = footer_app.find(
            (f) => f.label.toLowerCase() === 'update_store_location',
        )
        setRender(item ? true : false)
    }, [footer_app])

    function openUpdateModal() {
        let title = 'Actualizar ubicación de la tienda'
        let desc =
            'Se actualizará la ubicación de la tienda con tu posición actual. Verificá que te encontrás en el punto de venta antes de continuar'
        let button = 'Cancelar'
        let goToButton = 'Aceptar'

        openBottomSheet(
            <BottomSheetAlert
                image={require('../../../assets/store_placement.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={(dat) => closeBottomSheet(dat)}
                buttonGoto={goToButton}
                goto={() => updateLocation()}
                closeButtonStyles={{ borderWidth: 0 }}
            />,
        )
    }

    async function updateLocation() {
        if (isSending.current === true) return

        try {
            if (!isConnected || !hasInternet)
                throw new Error(
                    'Necesitas conexion a internet para aceptar los términos y condiciones',
                )

            isSending.current = true

            const authToken = await getAuthToken()
            const headers = {
                'Content-Type': 'application/json',
                Authorization: authToken || '',
            }
            const body = {
                lat: userInfo?.lat || '',
                lng: userInfo?.lng || '',
                store_id: userInfo?.storeID || '',
            }

            const response = await sendRequest(
                `${apiUrl}/oneapp/update_pos_location`,
                'POST',
                headers,
                body,
                2,
                60,
                null,
                [],
                false,
            )
            // console.log('RESPONSE ACCEPTANCE ==>', JSON.stringify(response))
            if (response.status != 1) {
                console.log('Error de response', response)
                return
            }
            const single = response.response?.single || null
            if (!single) {
                setToast('Error al actualizar la ubicación')
                console.log('No hay single', single)
                return
            }
            const { lat, lng, store_id, address } = single
            await schedulesServices.updateStoreLocation(store_id, lat, lng, address)
            setToast('Ubicación actualizada con éxito')
            onUpdate?.()
            console.log('RESPUESTA DEL SERVICIO ===>', JSON.stringify(single))
            closeBottomSheet(true)
        } catch (e) {
            console.log('[UpdatingLocationError] ==>', e)
        } finally {
            isSending.current = false
        }
    }
    if (!render) return null

    const renderIcon = () => {
        let icon = <GpsFixIcon color={iconColor} size={iconSize} />
        if (false) {
            icon = (
                <Ionicons
                    name='logo-whatsapp'
                    size={iconSize}
                    color={iconColor || theme.colors.primary}
                />
            )
        }
        return icon
    }
    return (
        <Pressable onPress={() => openUpdateModal()} style={{ ...style }}>
            {renderIcon()}
        </Pressable>
    )
}
